export const dateFormat = 'Y-MM-DD';
export const dateTimeFormat = 'Y-MM-DD HH:mm';
export const dateShowFormat = 'DD.MM.yyyy';
export const dateTimeShowFormat = 'DD.MM.yyyy HH:mm';
export const timeShowFormat = 'HH:mm';
